const EXTRAS = {
  LIFTGATE: 'LIFTGATE',
  SIDE_LOAD: 'SIDE_LOAD',
  TOP_LOAD: 'TOP_LOAD',
};

const t = {
  shipper: 'Shipper',
  user: 'User',
  price: 'Price',
  LIFTGATE: 'Tail lift',
  SIDE_LOAD: 'Curtain sider',
  TOP_LOAD: 'Retractable roof',
  max_height: 'Max height',
};

const t_stop = {
  stop: 'Stop',
  types: {
    PICKUP: 'Pick-up',
    DROPOFF: 'Drop-off',
  },
  company: 'Company',
  city: 'City',
  times: 'Time window',
  reference: 'Reference',
  instructions: 'Instructions',
  handling: 'Handling',
  load: 'Load',
  instructions_edited: 'Instructions to driver edited',
};

const fieldHasChanges = (field) => !!field?.changed;

const someHasChanges = (fields) => fields.some(fieldHasChanges);

const filterOutSelectedFields = (field) => !['loads'].includes(field);
const filterOutSelectedFieldsFromLoad = (field) => !['id'].includes(field);

const loadHasChanges = (load) => {
  return Object.keys(load)
    .filter(filterOutSelectedFieldsFromLoad)
    .some((loadKey) => fieldHasChanges(load[loadKey]));
};

const stopHasChanges = (stop) => {
  const stopKeys = Object.keys(stop).filter(filterOutSelectedFields);

  const stopHasModifiedProperties = stopKeys.some((stopKey) => fieldHasChanges(stop[stopKey]));
  const stopHasModifiedLoads = Array.isArray(stop?.loads)
    ? stop?.loads?.some(loadHasChanges)
    : false;

  return stopHasModifiedProperties || stopHasModifiedLoads;
};

export { t, t_stop, EXTRAS, fieldHasChanges, someHasChanges, stopHasChanges, loadHasChanges };
